import $ from 'jquery'
import Cookies from 'js-cookie'

const CSRF_COOKIE_NAME = '_csrf_token'

const requiresCSRF = options =>
  ['post', 'delete'].includes(options.type.toLowerCase()) ||
  (options.custom != null ? options.custom.forceCSRF : undefined)

const getCsrfToken = () => Cookies.get(CSRF_COOKIE_NAME)

// this catch-all ajax transport makes sure post request have CSRF tokens.
// it basically suspends any post request if a CSRF token is not present, tries
// to fetch a CSRF token from the login server and then executes the post request.

export default function installAjaxPrefilter() {
  $.ajaxTransport('+*', function(options) {
    // no need to do anything if this isn't a post request or if we already have
    // a CSRF token.
    if (!requiresCSRF(options) || getCsrfToken() != null || options.hasCSRF || window.isTesting) {
      return null
    }

    return {
      send(headers, completeCallback) {
        // wrap ajax response in a format completeCallback can understand
        const getResponses = function(jqXHR) {
          const responses = {}
          Object.keys(options.responseFields || {}).forEach(type => {
            const field = options.responseFields[type]
            if (jqXHR[field] != null) responses[type] = jqXHR[field]
          })
          return responses
        }

        // try and get a CSRF token from the login server
        return $.get('/login/get').always(function() {
          // execute the original request, mark it with hasCSRF so that this
          // transport doesn't run again in case CSRF fetching failed
          options.hasCSRF = true
          return $.ajax(options)
            .done((data, textStatus, jqXHR) =>
              // run completeCallback so that the original jqXHR gets resolved
              completeCallback(
                jqXHR.status,
                textStatus,
                getResponses(jqXHR),
                jqXHR.getAllResponseHeaders()
              )
            )
            .fail((jqXHR, textStatus) =>
              completeCallback(
                jqXHR.status,
                textStatus,
                getResponses(jqXHR),
                jqXHR.getAllResponseHeaders()
              )
            )
        })
      },
      abort() {}
    }
  })

  $.ajaxPrefilter(function(options, originalOptions, jqXHR) {
    // attach the CSRF token to all post requests
    if (requiresCSRF(options)) {
      const csrfToken = getCsrfToken()
      if (csrfToken != null) {
        jqXHR.setRequestHeader('X-CSRF-Token', csrfToken)
      }
    }
  })
}
